
import { connect } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";

import { ApplicationState } from "../../../redux/ApplicationState";
import { resetStates } from "../../../actions/Common";
import { getLanguageMasterResp, getMasterHealthPlan } from "../../../actions/Master";
import { checkEligibility, createPatient, getHealthPlanDetailsByBenefitPlanUid, getPatientFromMBI, information, logContractIdPBPDetails, patientInformationById, saveEligibilityInformation, saveMemberInfo } from "../../../actions/Patient";
import { EligibilityCheck, EligibilityInformation, GetPatient, GetPatientInformationPayload, LogContractIdPbpPayload, MemberInfoData, SaveInformation } from "../../../models/Patient";
import { getListResult } from "../../../utils";
import { UserPageTrack } from "../../../models/User";
import { postUserPageTrack } from "../../../actions/UserAction";
import { TabData } from "../../../models/TabSessionStorage";
import { saveTabSessionStorageResp } from "../../../actions/TabSessionStorage";
import PriorAuthWorkFlow from "../components";

const mapStateToProps = ({
  healthPlanState,
  checkEligibilityState,
  tabSessionStorageState,
  patientFromMbiState,
  benefitPlanUidState,
  loggedInUserState,
  patientInformationByIdState,
  createPatientState,
  memberInfoDataState,
  informationState,
  logContractIdPBPDetailsState,
  masterLanguageState
}: ApplicationState) => ({
  healthPlanState: getListResult(healthPlanState.response),
  checkEligibilityData: checkEligibilityState,
  TabSessionStorage: tabSessionStorageState,
  patientFromMbiState: patientFromMbiState.response,
  benefitPlanUidState: benefitPlanUidState.response,
  loggedInUserState: loggedInUserState.response,
  patientInformationByIdState: patientInformationByIdState.response,
  createPatientState: createPatientState.response,
  memberInfoDataState: memberInfoDataState.response,
  informationState: informationState.response,
  createPatientErrorState: createPatientState.error,
  informationErrorState: informationState.error,
  logContractIdPBPDetailsState: logContractIdPBPDetailsState.response,
  masterLanguageState: masterLanguageState.response,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    saveTabSessionStorage: (sessionData: TabData) => {
      dispatch(saveTabSessionStorageResp(sessionData));
    },
    resetStates: (actionType: string, field?: string) => {
      dispatch(resetStates(actionType, field));
    },
    getMasterHealthPlan: () => {
      dispatch(getMasterHealthPlan());
    },
    checkEligibility: (payload: EligibilityCheck) => {
      dispatch(checkEligibility(payload));
    },
    postUserPageTrack: (payload: UserPageTrack) => {
      dispatch(postUserPageTrack(payload));
    },
    saveEligibilityInformation: (sessionData: EligibilityInformation) => {
      dispatch(saveEligibilityInformation(sessionData));
    },
    getPatientFromMBI: (payload: GetPatient) => {
      dispatch(getPatientFromMBI(payload));
    },
    getHealthPlanDetailsByBenefitPlanUid: (benefitPlanUid: string) => {
      dispatch(getHealthPlanDetailsByBenefitPlanUid(benefitPlanUid));
    },
    createPatient: (payload: FormData) => {
      dispatch(createPatient(payload));
    },
    information: (payload: SaveInformation) => {
      dispatch(information(payload));
    },
    getPatientInformationById: (payload: GetPatientInformationPayload) => {
      dispatch(patientInformationById(payload));
    },
    saveMemberInfo: (payload: MemberInfoData) => {
      dispatch(saveMemberInfo(payload))
    },
    updateLogContractIdPbp: (payload: LogContractIdPbpPayload) => {
      dispatch(logContractIdPBPDetails(payload));
    },
    getLanguageMaster : () => {
      dispatch(getLanguageMasterResp());
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PriorAuthWorkFlow);
